import {
  NgModule
} from '@angular/core';
import {
  BreadcrumbComponent
} from './breadcrumb.component';
import {
  CommonModule
} from '@angular/common';
import {
  RouterModule
} from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    BreadcrumbComponent
  ],
  exports: [
    BreadcrumbComponent
  ],
  providers: [
  ],
  entryComponents: [],
})
export class BreadcrumbModule {
}
